export default "__VITE_ASSET__6846bf28__"